// extracted by mini-css-extract-plugin
export default {"team":"Team_team__44oTZ","teamBtn":"Team_teamBtn__eEW0V"};